import { FavoriteCollectionService, PersonalContentApiError } from '@aipb/gulliver/personal-content/data-access';
import { Collection } from '@aipb/gulliver/personal-content/model';
import { getCollectionLabel } from '@aipb/gulliver/personal-content/util';
import { ConfirmDialogService } from '@aipb/shared/dialog';
import { SnackbarService } from '@aipb/shared/util/snackbar';
import { UseCase } from '@aipb/shared/util/usecase';
import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { catchError, mergeMap, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeleteCollectionUseCase implements UseCase<Collection, Observable<void>> {
  private confirmDialog = inject(ConfirmDialogService);
  private snackbar = inject(SnackbarService);
  private favoriteCollectionService = inject(FavoriteCollectionService);
  private transloco = inject(TranslocoService);

  execute(collection: Collection) {
    return this.favoriteCollectionService.remove(collection.id).pipe(
      catchError((err: PersonalContentApiError) => {
        // trying to remove non-empty collection
        if (err.code === -26) {
          return this.confirmDialog
            .open$({
              title: 'personal_content.messages.delete_collection_title',
              content: 'personal_content.messages.delete_collection_message'
            })
            .pipe(
              mergeMap((confirmed: boolean) => {
                if (confirmed) {
                  return this.favoriteCollectionService.remove(collection.id, true);
                } else {
                  throw new Error('Error');
                }
              })
            );
        }

        throw new Error('Error');
      }),
      tap(() => {
        this.snackbar.open(
          this.transloco.translate('personal_content.titles.collection_deleted', {
            value: getCollectionLabel(collection)
          }),
          'success'
        );
      })
    );
  }
}
